import * as FirstQuarterMoon from "svg/assets/Firstquarter.svg";
import * as FullMoon from "svg/assets/Fullmoon.svg";
import * as LastQuarterMoon from "svg/assets/Lastquarter.svg";
import * as NewMoon from "svg/assets/Newmoon.svg";

export const getMoonSvg = (moonPhase: string) => {
    switch (moonPhase) {
        case "fullmåne":
            return FullMoon;
        case "nymåne":
            return NewMoon;
        case "första kvarteret":
            return FirstQuarterMoon;
        case "sista kvarteret":
            return LastQuarterMoon;
        default:
            return "";
    }
};
